import { ToggleButton, ToggleButtonGroup, ToggleButtonGroupProps } from '@mui/material';
import React from 'react';

interface Option {
    value: number;
    label?: string;
    disabled?: boolean;
}

interface QuantityToggleGroupProps extends Omit<ToggleButtonGroupProps, 'value' | 'onChange'> {
    value: number;
    onChange: (newValue: number) => void;
    options?: Option[];
    width?: number | string;
    color?: 'primary' | 'secondary' | 'success' | 'info' | 'warning' | 'error';
}

const QuantityToggleGroup: React.FC<QuantityToggleGroupProps> = ({
    value,
    onChange,
    options = [
        { value: 0, label: '0 j' },
        { value: 0.5, label: '0.5 j' },
        { value: 1, label: '1 j' },
    ],
    width = 45,
    color = 'success',
    size = 'small',
    ...props
}) => {
    return (
        <ToggleButtonGroup
            value={value}
            exclusive
            onChange={(_, newValue) => {
                if (newValue !== null) onChange(newValue);
            }}
            size={size}
            color={color}
            sx={{
                minWidth: 150,
                p: '5px',
                height: '35px',
                '& .MuiToggleButton-root': {
                    width,
                    minWidth: width,
                    flex: 1,
                    fontSize: 12,
                },
            }}
            {...props}
        >
            {options.map((option) => (
                <ToggleButton key={option.value} value={option.value} disabled={option.disabled}>
                    {option.label ?? option.value}
                </ToggleButton>
            ))}
        </ToggleButtonGroup>
    );
};

export default QuantityToggleGroup;
